'use client';
import { supabase } from '@/lib/supabase';

export async function trackPageView(page: string = '/') {
  try {
    const referrer = typeof document !== 'undefined' ? document.referrer || null : null;
    await supabase.from('page_views').insert({ page, referrer });
  } catch {
    // silently ignore tracking errors
  }
}
